const webAppCommonFeaturesEnums = new Map();

webAppCommonFeaturesEnums.set('rake', '/rake'); //rake
webAppCommonFeaturesEnums.set('sms_feature', '/shopPromotion'); //sms feature shop promotion screen
webAppCommonFeaturesEnums.set('bahi_khata', '/bahiKhata'); //shop promotion screen
webAppCommonFeaturesEnums.set('distributor_list', '/distributor'); //distributor list screen

export default webAppCommonFeaturesEnums;
